import React from 'react';
import NewImageLap from './NewImageLap';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact"



function grillLap() {
  return (
    <div className="grill" style={{marginTop : "10%"}}>
      <MDBContainer>
        <MDBRow>
          <MDBCol lg="4" md="4"><NewImageLap link="https://www.npmjs.com/package/basic-linechart" name="NPM lib basic-lineChart" date="2020-2021" addrImage="linechart.jpg"  /><div className="l3"></div><div className="l4"></div></MDBCol>
          <MDBCol lg="4" md="4"><NewImageLap link="https://mitnoos.com/Spaceshooter/robot.html" name="Stars Wars Game (full js)" date="2020-2021" addrImage="spaceshooter.jpg" /><div className="l3"></div><div className="l4"></div></MDBCol>
          <MDBCol lg="4" md="4"><NewImageLap link="http://www.lapetiteepope.fr/" name="La Petite Epopée" date="2019-2021"  addrImage="lpe.jpg"/><div className="l3"></div><div className="l4"></div></MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default grillLap;